@if (facility) {
    <ui-culture-map-item-facility-detail
        [facility]="facility"
        (mapItemTriggeredById)="triggerMapItemById($event)"
    />
}

@if (offering) {
    <ui-culture-map-item-offering-detail
        [offering]="offering"
        (mapItemTriggeredById)="triggerMapItemById($event)"
    />
}
